/* Remember the collection grid when opening a product in this tab. */
(function () {
  'use strict';
  if (!/^\/collections\/[^/]+\/?$/.test(location.pathname)) return;
  var prefix = 'wfs-collection-return-v1:';
  var maxAge = 30 * 60 * 1000;
  var facets, restoring = false, departed = false;
  var navigation = performance.getEntriesByType('navigation')[0];
  var returning = !!navigation && navigation.type === 'back_forward';
  var timers = [], resizeObserver, savedBehavior, interruptHandler;

  function path() { return location.pathname + location.search; }
  function read(state) {
    try {
      if (!state || !state.wfsCollectionReturn) return null;
      var snapshot = JSON.parse(sessionStorage.getItem(prefix + state.wfsCollectionReturn));
      if (!snapshot || snapshot.path !== path() || Date.now() - snapshot.time > maxAge) return null;
      if (typeof snapshot.html !== 'string') snapshot.html = window.WFSCollectionCache.unpack(snapshot.html);
      return snapshot;
    } catch (error) { return null; }
  }
  function stop() {
    timers.forEach(clearTimeout);
    timers = [];
    if (resizeObserver) resizeObserver.disconnect();
    if (savedBehavior !== undefined) {
      document.documentElement.style.scrollBehavior = savedBehavior;
      savedBehavior = undefined;
    }
    if (interruptHandler) {
      ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (event) {
        window.removeEventListener(event, interruptHandler);
      });
      interruptHandler = null;
    }
    restoring = false;
  }
  function position(snapshot) {
    stop();
    restoring = true;
    savedBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    function place() {
      var target = snapshot.y;
      if (snapshot.anchor && Math.abs(innerWidth - snapshot.width) > 2) {
        var links = facets.container.querySelectorAll('a[data-pr-href]');
        var anchor = Array.prototype.find.call(links, function (link) {
          return link.getAttribute('href') === snapshot.anchor;
        });
        if (anchor) target = scrollY + anchor.getBoundingClientRect().top - snapshot.offset;
      }
      window.scrollTo(0, target);
    }
    place();
    [50, 150, 300, 600, 1000, 1600].forEach(function (delay) {
      timers.push(setTimeout(place, delay));
    });
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(place);
      resizeObserver.observe(facets.container);
    }
    timers.push(setTimeout(function () {
      stop();
      // Reconnect any on-scroll buttons after the restored layout is stable.
      facets.$container.find('[data-load-onscroll]').removeClass('t4s-lm-onscroll-init');
      facets.clickOnScrollButton();
    }, 2000));
    interruptHandler = stop;
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (event) {
      window.addEventListener(event, interruptHandler, { passive: true });
    });
  }
  function hydrate(snapshot) {
    if (snapshot.section !== facets.main) return false;
    facets.$container2.html(snapshot.html);
    facets.$resultCount.html(snapshot.resultCount);
    facets.$container.find('[data-load-onscroll]').removeClass('t4s-lm-onscroll-init');
    facets.$container.find('.t4s-product').removeClass('t4s_observered');
    facets.$filterArea = facets.$section.find('[data-filter-area]');
    facets.updateListing();
    if (window.T4SThemeSP) {
      T4SThemeSP.reinitProductGridItem();
      T4SThemeSP.PopupMFP();
      if (/Isotope$/.test(facets.typeAjax)) {
        facets.$container.find('.isotopet4s').removeClass('isotopet4s-enabled');
        T4SThemeSP.Isotopet4s.init(facets.$container.find('.isotopet4s'));
        T4SThemeSP.ProductItem.resizeObserver();
      }
    }
    jQuery_T4NT('body').trigger('currency:update');
    return true;
  }
  function save(link) {
    if (!facets || restoring) return;
    try {
      var token = Date.now().toString(36) + Math.random().toString(36).slice(2, 9);
      var snapshot = {
        path: path(), time: Date.now(), section: facets.main,
        html: window.WFSCollectionCache ? window.WFSCollectionCache.pack(facets.$container2.html()) : facets.$container2.html(), resultCount: facets.$resultCount.html(),
        y: scrollY, width: innerWidth,
        anchor: link ? link.getAttribute('href') : null,
        offset: link ? link.getBoundingClientRect().top : 0
      };
      // Bound the cache so long browsing sessions do not fill session storage.
      var keys = Object.keys(sessionStorage).filter(function (key) { return key.indexOf(prefix) === 0; });
      keys.sort().slice(0, Math.max(0, keys.length - 2)).forEach(function (key) { sessionStorage.removeItem(key); });
      sessionStorage.setItem(prefix + token, JSON.stringify(snapshot));
      history.replaceState(Object.assign({}, history.state || {}, { wfsCollectionReturn: token }), '', location.href);
      departed = true;
    } catch (error) { /* Native browser restoration remains the fallback. */ }
  }

  window.WFSCollectionReturn = {
    restoring: function () { return restoring; },
    attach: function (instance) {
      facets = instance;
      if (!returning) return;
      var snapshot = read(history.state);
      if (snapshot && hydrate(snapshot)) {
        position(snapshot);
      }
    },
    popstate: function (instance, event) {
      facets = instance;
      // Only suppress the theme's reload during a return from another page.
      // Ordinary Back navigation through filter/sort history stays with the theme.
      if (!restoring) return false;
      var snapshot = read(event.state);
      if (!snapshot) return false;
      return true;
    }
  };
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || !facets || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    var url = new URL(link.href, location.href);
    if (url.origin === location.origin && /\/products\//.test(url.pathname)) save(link);
  }, true);
  window.addEventListener('pagehide', function () {
    if (!departed) return;
    // The click snapshot contains the products and position before departure.
    stop();
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !facets) return;
    var snapshot = read(history.state);
    if (snapshot) {
      departed = false;
      position(snapshot);
    }
  });
})();
